import { useEffect, useState } from "react";
import { ExternalPromoMedia, Promo } from "../../interfaces/promo";
import { PromoContext } from "./PromoContext";
import { usePromoFetch } from "../../hooks/fetch/usePromoFetch";
import useConfig from "../../hooks/config/useConfig";


interface props {
  children: JSX.Element | JSX.Element[];
}


export const PromoProvider = ({ children }: props) => {

  const [countryPromo, setCountryPromo] = useState<Promo>()
  const [externalPreheaders, setExternalPreheaders] = useState<ExternalPromoMedia[]>([])
  const [externalPopup, setExternalPopup] = useState<ExternalPromoMedia | null>(null)
  const [externalPromosLoaded, setExternalPromosLoaded] = useState(false)
  const { getCountryPromo, getCurrentPromos } = usePromoFetch()
  const { config, country } = useConfig()

  useEffect(() => {
    if (config && config.country) {
      getCountryPromo(config.country.id).then(response => {
        if (response.success) {
          setCountryPromo(response.data)
        } else {
          setCountryPromo(undefined)
        }
      })
    }

  }, [config])

  useEffect(() => {
    const cid = config?.country?.id
    if (!cid || cid < 1) {
      setExternalPreheaders([])
      setExternalPopup(null)
      setExternalPromosLoaded(true)
      return
    }
    let cancelled = false
    setExternalPromosLoaded(false)
    getCurrentPromos(cid).then((response) => {
      if (cancelled) return
      if (response.success && response.data) {
        const list = (response.data.preheaders || []).filter(
          (p): p is ExternalPromoMedia =>
            !!p?.desktop_url?.trim() && !!p?.mobile_url?.trim()
        )
        setExternalPreheaders(list)
        setExternalPopup(response.data.popup)
      } else {
        setExternalPreheaders([])
        setExternalPopup(null)
      }
      setExternalPromosLoaded(true)
    })
    return () => { cancelled = true }
  }, [config?.country?.id])

  return (
    <PromoContext.Provider
      value={{
        countryPromo: countryPromo,
        externalPreheaders,
        externalPopup,
        externalPromosLoaded,
      }}
    >

      {children}
    </PromoContext.Provider>
  )
};
